import { apiJson } from './api';

const getBaseUrl = () => import.meta.env.VITE_API_BASE_URL || 'https://dumas.solutions';

export interface NewsItem {
  id: string;
  title: string;
  summary: string;
  url: string;
  source: string;
  date: string;
  imageUrl?: string;
  categories?: string[];
}

interface FeedResponse {
  success: boolean;
  data: NewsItem[];
  count: number;
}

export async function getFeed(): Promise<NewsItem[]> {
  const data = await apiJson<FeedResponse>('/api/mobile/feed');
  if (!data.success || !Array.isArray(data.data)) return [];
  const base = getBaseUrl().replace(/\/$/, '');
  return data.data.map((item) => ({
    ...item,
    imageUrl: item.imageUrl?.startsWith('/') ? `${base}${item.imageUrl}` : item.imageUrl,
  }));
}

export function formatFeedDate(dateString: string): string {
  const d = new Date(dateString);
  const day = d.getUTCDate().toString().padStart(2, '0');
  const month = (d.getUTCMonth() + 1).toString().padStart(2, '0');
  const year = d.getUTCFullYear();
  return `${day}/${month}/${year}`;
}

/** Formato largo: "sábado, 7 de febrero de 2026" */
export function formatFeedDateLong(dateString: string): string {
  const d = new Date(dateString);
  return d.toLocaleDateString('es-MX', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
}
